import { Box } from "@material-ui/core";
import React from "react";

import WeeklyEACSummaryFixedTable from "./WeeklyEACSummaryFixedTable";
import WeeklyEACSummaryWeeklyValues from "./WeeklyEACSummaryWeeklyValues";
// import WeeklyEACSummaryTotalsValues from "./WeeklyEACSummaryTotalsValues"; // ITD/Remaining Forecast/Total hidden for now
import {
  DIRECT_LABOR_FIXED_TOTAL_WIDTH,
  TOTALS_GROUP_WIDTH,
} from "./weeklyEACColumns";

// ITD, Remaining Forecast and Total (3 groups) are intentionally hidden above, but Direct Labor's
// own totals table still occupies that width in its scroll box. Without a matching placeholder
// here, this table's scrollable content is narrower than Direct Labor's, so scrollLeft syncing
// clips at this box's shorter max scroll range. An empty spacer of the same width keeps both
// scroll ranges equal so the sync stays accurate across the full width.
const HIDDEN_TOTALS_WIDTH = TOTALS_GROUP_WIDTH * 3;

const noDataStyle = {
  textAlign: "center",
  fontWeight: 600,
  background: "#fff",
  padding: "24px 0",
};

export default function WeeklyEACSummaryTable({
  weeklyTotals = [],
  type,
  isEdit,
  onCreditOverCeilingChange,
  scrollRef,
  onScroll,
}) {
  return (
    <Box style={{ marginTop: "16px" }}>
      <div
        style={{
          width: "220px",
          height: "36px",
          padding: "0 0 0 12px",
          fontSize: "15px",
          color: "#ffffff",
          backgroundColor: "#000",
          borderRadius: "0 10px 0 0",
          display: "flex",
          alignItems: "center",
        }}
      >
        CLIN Summary
      </div>
      {weeklyTotals.length === 0 ? (
        <div style={noDataStyle}>No Data</div>
      ) : (
        <Box display="flex" flexDirection="row" style={{ marginTop: "8px" }}>
          <Box
            style={{
              boxShadow: "0px 3px 6px #00000029",
              width: DIRECT_LABOR_FIXED_TOTAL_WIDTH,
              marginRight: "8px",
            }}
          >
            <WeeklyEACSummaryFixedTable type={type} />
          </Box>
          <Box
            ref={scrollRef}
            onScroll={onScroll}
            style={{ overflowX: "auto", boxShadow: "0px 3px 6px #00000029" }}
          >
            <Box display="flex" flexDirection="row">
              <Box style={{ marginRight: "8px" }}>
                <WeeklyEACSummaryWeeklyValues
                  weeklyTotals={weeklyTotals}
                  type={type}
                  isEdit={isEdit}
                  onCreditOverCeilingChange={onCreditOverCeilingChange}
                />
              </Box>
              <Box style={{ minWidth: HIDDEN_TOTALS_WIDTH }} />
              {/* <Box>
                <WeeklyEACSummaryTotalsValues weeklyTotals={weeklyTotals} />
              </Box> */}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}
